import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAccount } from 'Models/User';

const initialState: { account: IAccount | null } = {
  account: null
};

export const accountSlice = createSlice({
  initialState,
  name: 'accountSlice',
  reducers: {
    setAccount: (state, action: PayloadAction<IAccount>) => {
      state.account = action.payload;
    }
  },
});

export default accountSlice.reducer;

export const { setAccount } = accountSlice.actions;
